var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ext-btns inline m-r"},[_c('a',{staticClass:"m-l",on:{"click":_vm.refresh}},[_c('u-icon',{attrs:{"name":"retweet","type":"fa"}}),_c('u-tooltip',{attrs:{"offset":[4,4]}},[_vm._v("Atualizar")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }